import { ApiClient } from "../../ApiClient";
import { WarehouseConnection } from "@domain/inventory/models/WarehouseConnection";
import { WarehouseConnectionMapper } from "../mappers/WarehouseConnectionMapper";
import { CreateWarehouseConnectionRequestDto, WarehouseConnectionDto } from "../dto/WarehouseConnectionDto";
import { WarehouseConnectionRule } from "@domain/inventory/models/WarehouseConnectionRule";
import { MutationType } from "@domain/inventory/enums/MutationType.enum";

export class WarehouseConnectionDataSource {
    constructor(private api: ApiClient) { }

    async getWarehouseConnections(warehouseId: string): Promise<WarehouseConnection[]> {
        try {
            const response = await this.api.get<WarehouseConnectionDto[]>(`/inventory/warehouse-connections?warehouseId=${warehouseId}`);
            return response.data.map(WarehouseConnectionMapper.toModel);
        } catch (error) {
            throw new Error('Failed to fetch warehouse connections');
        }
    }

    async getWarehouseConnection(id: string): Promise<WarehouseConnection> {
        try {
            const response = await this.api.get<WarehouseConnectionDto>(`/inventory/warehouse-connections/${id}`);
            return WarehouseConnectionMapper.toModel(response.data);
        } catch (error) {
            throw new Error('Failed to fetch warehouse connection');
        }
    }

    async createWarehouseConnection(warehouseId: string, rules: WarehouseConnectionRule[], mutationType: MutationType, activeFrom?: Date, activeUntil?: Date): Promise<WarehouseConnection> {
        try {
            const response = await this.api.post<WarehouseConnectionDto>(
                '/inventory/warehouse-connections',
                {
                    warehouseId,
                    rules,
                    mutationType,
                    activeFrom,
                    activeUntil
                }
            );

            return WarehouseConnectionMapper.toModel(response.data);
        } catch (error) {
            throw new Error('Failed to create warehouse connection');
        }
    }

    async updateWarehouseConnection(id: string, rules: WarehouseConnectionRule[], mutationType: MutationType, activeFrom?: Date, activeUntil?: Date): Promise<WarehouseConnection> {
        try {
            const response = await this.api.put<WarehouseConnectionDto>(
                `/inventory/warehouse-connections/${id}`,
                {
                    rules,
                    mutationType,
                    activeFrom,
                    activeUntil
                }
            );
            return WarehouseConnectionMapper.toModel(response.data);
        } catch (error) {
            throw new Error('Failed to update warehouse connection');
        }
    }

    async deleteWarehouseConnection(id: string): Promise<void> {
        try {
            await this.api.delete(`/inventory/warehouse-connections/${id}`);
        } catch (error) {
            throw new Error('Failed to delete warehouse connection');
        }
    }
}